"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOnUpManager = void 0;
const SelectManager_1 = require("./SelectManager");
/**
 * SelectOnUpManager is a convenience class that extends SelectManager
 * and automatically configures it to select on pointer up events.
 *
 * This maintains backward compatibility while leveraging the unified
 * SelectManager implementation.
 */
class SelectOnUpManager extends SelectManager_1.SelectManager {
    constructor(id, interactionEffect, deselectOnEmpty) {
        // Call SelectManager constructor with "up" flag
        super(id, interactionEffect, deselectOnEmpty, "up");
    }
}
exports.SelectOnUpManager = SelectOnUpManager;
//# sourceMappingURL=SelectOnUpManager.js.map